import React from 'react'
import Page from '../components/containers/Page'
import { project } from '../data/data'

const Company = () => {

  document.title = `COMPAGNIE — ${project.website}`

  return (

    <Page offset>
      <div className='resp'>
        <h1>Compagnie</h1>
      </div>
    </Page>
  )
}

export default Company
